import { InvoicingCutoffModel } from './../invoicing/invoicing-cutoff.model';
import { RentalPeriodModel } from './rental-period.model';
import { DevolutionStateEnums } from "src/app/enum/devolution-state-enums";
import { CostCenterModel } from "../archive/cost-center.model";

export class DevolutionModel {
  devolutionId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  alterNumber: number | null = null;
  costCenterId: number = 0;
  costCenter: CostCenterModel = new CostCenterModel();
  consecutivePredevolution: number | null = null;
  datePredevolution: Date | null = null;
  isPredevolution: boolean = false;
  advertiser: string | null = null;
  dateDevolution: Date = new Date;
  rentalPeriodId: number = 0;
  rentalPeriod: RentalPeriodModel = new RentalPeriodModel();
  dateInvoice: Date = new Date;
  swDontChargeInvoiceDay: boolean = false;
  devolutionStateId: number = DevolutionStateEnums.abierto;
  swBlock: boolean = false;
  invoicingCutoffId: number | null = null;
  invoicingCutoff: InvoicingCutoffModel | null = null;
  transportValue: number = 0;
  transportValuePay: number = 0;
  transporterId: number = 0;
  vehicleId: number = 0;
  wildcard: string | null = null;
  wildcard2: string | null = null;
  printObservation: string | null = null;
  observation: string | null = null;
  isTransfer: boolean = false;
  datePickup: Date = new Date;
  conceptTypeRequirementId: number | null = null;
  conceptDelayReasonId: number | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
  convertDevolutionWithQuatities: boolean = false;
}